---
en:
  overview:
    48hrs: "(48hr)"
    dir:
      asc: "▼"
      desc: "▲"
    effect_overflow_tip: Check if current max production value is correct for this power plant
    precipitation: Precipitation (48 hours forecast)
    sensor_values:
      above_limit: Above limit
      below_limit: Below limit
      within_limits: Within limits
    sort:
      current_effect: Current Production
      current_income: Income
      name: Name
      precipitation: Precipitation
      rated_power_mw: Max capacity
      utilization: Utilization
    variants:
      advanced: Advanced card
      basic: Basic card
